// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setCaregiverList,
  setCaregiverEdit,
  resetCaregiverManagement
} from 'src/store/modules/admin/caregiverManagement'

const initialState = {
  caregiverList: [],
  caregiverEdit: {}
}

export default handleActions(
  {
    [setCaregiverList](state, { payload: caregiverList }) {
      return {
        ...state,
        caregiverList
      }
    },

    [setCaregiverEdit](state, { payload: caregiverEdit }) {
      return {
        ...state,
        caregiverEdit
      }
    },

    [resetCaregiverManagement]() {
      return initialState
    }
  },
  initialState
)
